import { render } from "./InlineMessageAlert.vue?vue&type=template&id=206831f6&scoped=true"
import script from "./InlineMessageAlert.vue?vue&type=script&lang=js"
export * from "./InlineMessageAlert.vue?vue&type=script&lang=js"

import "./InlineMessageAlert.vue?vue&type=style&index=0&id=206831f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206831f6"],['__file',"src/components/general/InlineMessageAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "206831f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('206831f6', __exports__)) {
    api.reload('206831f6', __exports__)
  }
  
  module.hot.accept("./InlineMessageAlert.vue?vue&type=template&id=206831f6&scoped=true", () => {
    api.rerender('206831f6', render)
  })

}


export default __exports__